import { render, staticRenderFns } from "./FilterContactPickerWrapper.vue?vue&type=template&id=05d6fdce"
import script from "./FilterContactPickerWrapper.vue?vue&type=script&lang=js"
export * from "./FilterContactPickerWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports